import React, { useEffect, useState } from "react";
import { Clock, Briefcase, ArrowRight, AlertCircle, FileText } from "lucide-react";
import TiltCard from "../components/TiltCard";
import PageBanner, { SectionTitle } from "../components/PageBanner";
import { pageBanners } from "../data/mock";
import { DRIVE_NOT_CONNECTED, fetchSiteCareers } from "../lib/siteDrive";

export default function Careers() {
  const [status, setStatus] = useState("loading");
  const [connected, setConnected] = useState(false);
  const [error, setError] = useState("");
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    let live = true;
    fetchSiteCareers().then((d) => {
      if (!live) return;
      setJobs(d.files || []);
      setConnected(d.connected === true);
      setError(d.error || "");
      setStatus(d.connected ? "ready" : "empty");
    }).catch(() => {
      if (!live) return;
      setError(DRIVE_NOT_CONNECTED);
      setStatus("empty");
    });
    return () => { live = false; };
  }, []);

  return (
    <div className="page-enter">
      <PageBanner image={pageBanners.careers} title="Careers" subtitle="Build a rewarding career serving public healthcare and medical education in Andhra Pradesh." />

      <section style={{ padding: "50px 24px 60px" }}>
        <div style={{ maxWidth: 1300, margin: "0 auto" }}>
          <SectionTitle>Current Openings</SectionTitle>
          {status === "loading" && (
            <div data-testid="careers-loading" style={{ textAlign: "center", padding: 40, color: "#78716C", fontWeight: 600 }}>Loading openings…</div>
          )}
          {status !== "loading" && !connected && (
            <div data-testid="careers-drive-error" style={{ marginBottom: 16, padding: "14px 16px", background: "#FEF2F2", border: "1px solid rgba(220,38,38,0.28)", borderRadius: 12, color: "#B91C1C", fontSize: 13.5, display: "flex", gap: 8 }}>
              <AlertCircle size={16} style={{ flexShrink: 0, marginTop: 2 }} />
              {error || DRIVE_NOT_CONNECTED}. Job notices will appear here when Drive is connected on the server.
            </div>
          )}
          <div className="grid-eq grid-3" style={{ display: "grid", gap: 20 }} data-testid="careers-list">
          {jobs.map((j) => (
            <TiltCard key={j.id} intensity={4}>
              <div style={{ padding: 26 }} data-testid={`career-${j.id}`}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10 }}>
                  <div className="icon-tile">
                    <Briefcase size={20} />
                  </div>
                  {j.last_date && <span className="badge badge-red">Last date {j.last_date}</span>}
                </div>
                <h3 className="font-serif" style={{ fontSize: 18, color: "#1C1917", marginTop: 16, fontWeight: 700 }}>{j.title}</h3>
                {j.summary && <p style={{ fontSize: 13.5, color: "#57534E", marginTop: 10, lineHeight: 1.55 }}>{j.summary}</p>}
                <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginTop: 12, fontSize: 12.5, color: "#78716C" }}>
                  {j.date && <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}><Clock size={12} /> Posted {j.date}</span>}
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 22, paddingTop: 16, borderTop: "1px solid rgba(194,65,12,0.08)" }}>
                  <span style={{ fontSize: 12, color: "#78716C" }}>{j.has_file ? "PDF attached" : "Notice"}</span>
                  {(j.view || j.download || j.url) ? (
                    <a href={j.view || j.download || j.url} target="_blank" rel="noreferrer" data-testid={`career-apply-${j.id}`} className="btn-primary-3d" style={{ padding: "8px 14px", fontSize: 12.5, textDecoration: "none", display: "inline-flex", alignItems: "center" }}>
                      {j.has_file ? <><FileText size={12} style={{ marginRight: 4 }} /> View / Apply</> : <>Open <ArrowRight size={12} style={{ marginLeft: 4 }} /></>}
                    </a>
                  ) : (
                    <a href="mailto:md.apmerc@gmail.com?subject=Application" className="btn-primary-3d" style={{ padding: "8px 14px", fontSize: 12.5, textDecoration: "none" }}>Apply</a>
                  )}
                </div>
              </div>
            </TiltCard>
          ))}
          </div>
          {status !== "loading" && jobs.length === 0 && (
            <div data-testid="careers-empty" style={{ textAlign: "center", padding: 50, color: "#78716C" }}>
              <Briefcase size={36} style={{ opacity: 0.3, marginBottom: 10 }} />
              <div>{connected ? "No openings have been published yet." : "No openings to show while Drive is unavailable."}</div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
